export var unformatPhone = function unformatPhone(value) {
  if (!value) return value;
  var onlyNumbers = value.replace(/\D/gi, '');
  return onlyNumbers.slice(onlyNumbers.length - 10, onlyNumbers.length);
};

/**
 * @desc: хэширует строку с ctn в base64
 * @param ctn
 * @returns {string|*}
 */
export var hashCtn = function hashCtn(ctn) {
  if (typeof ctn !== 'string' || !ctn.length) {
    return ctn;
  }
  var strLength = ctn.length;
  var strToHash = "".concat(ctn.substring(0, strLength - 2)).concat(ctn[strLength - 1]).concat(ctn[strLength - 2]);
  return btoa(strToHash);
};

// TODO: временный костыль для исправления странного поведения функции, убирающей маску с телефона
export var unmaskPhoneFix = function unmaskPhoneFix(phone) {
  if (phone.startsWith('7')) {
    return phone.substring(2);
  }
  return phone;
};

/**
 * @desc: форматриует число в виде валюты
 * @param {number} num
 * @return {string} строка с отформатированным значением
 */
export var getLocalCurrencyStr = function getLocalCurrencyStr(num) {
  if (!num || typeof num !== 'number') {
    return '';
  }
  return num.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'rub'
  }).replace(',00', '');
};